import { notification } from 'antd'
import { ArgsProps } from 'antd/es/notification'
import { Icon } from 'shared/iconpack'

import { palette } from 'shared/config/styles/palette'

import './notification.css'

interface notificationParams extends ArgsProps {
  type?: 'error' | 'info' | 'success'
}

export const showNotification = ({
  message,
  type = 'info',
}: notificationParams) => {
  const typeClass = {
    error: {
      iconColor: palette.red_2,
    },
    info: {
      iconColor: palette.blue,
    },
    success: {
      iconColor: palette.dark_green_4,
    },
  }[type]
  notification.open({
    message,
    placement: 'top',
    className: `customNotification ${type} rounded-[12px]`,
    duration: 2,
    closeIcon: (
      <Icon
        name="close"
        color={palette.gray}
        className="min-w-[24px] opacity-60"
        width={24}
        height={24}
      />
    ),
    icon: (
      <Icon
        name="notification"
        color={typeClass.iconColor}
        width={24}
        height={24}
      />
    ),
  })
}
